/*
 * This component's name conflicts with Bootstrap reserve word Breadcrumb.
 * So it's named as BreadcrumbBar instead of just Breadcrumb. 
 * DC: 1/23/2021; LU: 3/11/2021
 */
import React from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Container, Row, Col } from "reactstrap";
import appConfig from "../data/appConfig";
import langUI from "../data/langUI";

const lvl2 = "About Us";
const lvl3 = "Services";
const lvl3Link = appConfig['pageSet']['servicesLink'];

// Home > About Us > Services > 法會消災、超薦、供僧登記表
const BreadcrumbBar = () => {
	return (
		<Container fluid={false} className="bc-section">
			<Row>
				<Col xs="12">
					<Breadcrumb>
						<BreadcrumbItem>
							<a href={appConfig["siteSet"]["link"]}>{langUI["home"]["en"]}</a>
						</BreadcrumbItem>
						<BreadcrumbItem>
							<a href={appConfig["pageSet"]["aboutUsLink"]}>{lvl2}</a>
						</BreadcrumbItem>
						<BreadcrumbItem>
							<a href={lvl3Link}>{lvl3}</a>
						</BreadcrumbItem>
						<BreadcrumbItem active>{appConfig["appSet"]["titleC"]}</BreadcrumbItem>
					</Breadcrumb>
				</Col>
			</Row>
		</Container>
	);
};

export default BreadcrumbBar;
